import React, {Component} from 'react'
import {CSSTransition, TransitionGroup} from 'react-transition-group'
import CloseBtn from '../../components/CloseBtn'
import InnerWrap from '../../components/InnerWrap'
import FactoryMenu from '../../components/FactoryMenu';
import FactoryMenuLink from '../../components/FactoryMenu/FactoryMenuLink';
import BackSound from '../../components/BackSound'
import Video from '../../components/Video'
import * as routes from '../../const/routes'
import * as videos from '../../const/videos'
import {withUiContext} from "../../UiContext";
import MenuBtn from "../../components/MenuBtn";
import NavContent from "../../components/NavContent";
import Languages from "../../const/languages";
import './Factory.scss'

import developmentIcon from '../../assets/img/factory/development.png'
import testsIcon from '../../assets/img/factory/tests.png'
import warrantyIcon from '../../assets/img/factory/warranty.png'
import constructionIcon from '../../assets/img/factory/construction.png'

import ProdArrowTop from '../../components/Svg/prod-arrow-top';
import ProdArrow2 from '../../components/Svg/prod-arrow2';
import ProdArrow1 from '../../components/Svg/prod-arrow1';

const sections = [
    {
        link:        routes.FACTORY2_PROD,
        isProdBtn: true,
        // icon: constructionIcon,
        coordinates: {
            x: 0,
            y: 82,
        },
        point: {
            size:   736,
            scaleY: 1,
        },
    },
    {
        label:       Languages.developmentAndDesign,
        labelPosition: 'top',
        link:        routes.FACTORY2_DEV,
        icon:  developmentIcon,
        coordinates: {
            x: -657,
            y: -80,
        },
        point: {
            size:   260,
            scaleY: 1,
        },
    },
    {
        label:       Languages.constructionAndInstallation,
        labelPosition: 'top',
        link:        routes.FACTORY2_BUILDING,
        icon: constructionIcon,
        coordinates: {
            x: 657,
            y: -80,
        },
        point: {
            size:   260,
            scaleY: 1,
        },
    },
    {
        label:       Languages.warrantyAndService,
        labelPosition: 'bottom',
        link:        routes.FACTORY2_WARRANTY,
        icon: warrantyIcon,
        coordinates: {
            x: 579,
            y: 240,
        },
        point: {
            size:   260,
            scaleY: 1,
        },
    },
    {
        label:       Languages.trials,
        labelPosition: 'bottom',
        link:        routes.FACTORY2_TRIALS,
        icon: testsIcon,
        coordinates: {
            x: -579,
            y: 240,
        },
        point: {
            size:   260,
            scaleY: 1,
        },
    },
];

class Prod extends Component {

    state = {
        driver: this.props.ui.driver,
        navContent: false,
    }

    toggleNav = (e) => {
        this.setState((prevState) => ({navContent: !prevState.navContent}))
    }

    onEnded = () => {
        this.setState({driver: false})
    }

    render() {
        const { driver, navContent } = this.state

        return (
            <InnerWrap video={videos.bg_factory_2} title={!driver && Languages.aboutZeto} lightBg={true} lightDecor={true}>
                <div className="hud__container-content">
                    {!driver && <MenuBtn className={`animated ${!navContent ? 'fadeInLeft' : 'fadeOutLeft'}`} onClick={this.toggleNav} onMouseEnter={this.props.ui.playOverSound}/>}

                    <TransitionGroup className="menu-outer">
                        {navContent &&
                            <CSSTransition timeout={300} classNames="menu-transition">
                                <NavContent onClose={this.toggleNav}/>
                            </CSSTransition>
                        }
                    </TransitionGroup>

                    <TransitionGroup>
                        {!driver &&
                            <CSSTransition timeout={300} classNames="menu-transition">
                                <FactoryMenu>
                                    <div className="factory-top-arrow">
                                        <ProdArrowTop />
                                    </div>
                                    <div className="factory-arrow-side">
                                        <ProdArrow1 />
                                    </div>
                                    <div className="factory-arrow factory-arrow_1">
                                        <ProdArrow2 />
                                    </div>
                                    <div className="factory-arrow factory-arrow_2">
                                        <ProdArrow2 />
                                    </div>
                                    <div className="factory-arrow factory-arrow_3">
                                        <ProdArrow2 />
                                    </div>
                                    { sections && sections.map((item, index) => {
                                        const { label, labelPosition, link, coordinates, point, icon, isProdBtn } = item;

                                        return (
                                            <FactoryMenuLink
                                                key = { index }
                                                label = { label }
                                                labelPosition = { labelPosition }
                                                link = { link }
                                                point = { point }
                                                icon = { icon }
                                                style = {{
                                                    left: coordinates.x,
                                                    top:  coordinates.y,
                                                }}
                                                isProdBtn = { isProdBtn }
                                            />
                                        );
                                    }) }
                                </FactoryMenu>
                            </CSSTransition>
                        }
                    </TransitionGroup>

                    <TransitionGroup>
                        {driver &&
                            <CSSTransition timeout={3000} classNames="fade">
                                <Video video={videos.driver} onEnded={this.onEnded}/>
                            </CSSTransition>
                        }
                    </TransitionGroup>
                </div>

                <div className="hud__container-controls">
                    {!driver && <BackSound navContent={navContent} lightBg={true} />}

                    <CloseBtn link={routes.HOME}/>
                </div>
            </InnerWrap>
        )
    }
}

export default withUiContext(Prod)
